import React from 'react'
import './loader.css'

export const Loader = () => {
    return (
        <div className="loaderWrapper">
            <center>
                <div className="loader"></div>
            </center>
        </div>
    )
}
